import script from "./BaseRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=d0496218&lang=css"

const __exports__ = script;

export default __exports__